import { CloseOutlined, EditOutlined, SettingOutlined } from '@ant-design/icons'
import { Button, Card, Flex, Modal, Tag } from 'antd'
import React from 'react'
import { FormConfigurationType } from '~/features/formConfiguration/common'

type Props = {
  formConfiguration: FormConfigurationType
  onUpdateSteps: () => void
  onUpdate: () => void
  onDelete: () => void
}

export const ListItem: React.FC<Props> = ({
  formConfiguration,
  onUpdate,
  onDelete,
  onUpdateSteps,
}) => {
  const confirmDelete = () => {
    Modal.confirm({
      title: 'Are you sure you want to delete this form?',
      content: 'This action cannot be undone.',
      okText: 'Yes',
      okType: 'danger',
      cancelText: 'No',
      onOk: () => onDelete(),
    })
  }

  return (
    <Card
      size="small"
      style={{ maxWidth: '400px', width: '100%' }}
      actions={[
        <Button
          key="update"
          icon={<EditOutlined />}
          type="text"
          onClick={() => onUpdateSteps()}
        />,
        <Button
          key="update"
          icon={<SettingOutlined />}
          type="text"
          onClick={() => onUpdate()}
        />,
        <Button
          key="delete"
          danger
          icon={<CloseOutlined />}
          type="text"
          onClick={() => confirmDelete()}
        />,
      ]}
    >
      <Flex flex={1}>
        <Flex vertical gap={8}>
          <Flex gap={8} vertical>
            <Flex>
              <Tag color="magenta-inverse">{formConfiguration.type}</Tag>

              {formConfiguration.key && (
                <Tag color="blue-inverse">{formConfiguration.key}</Tag>
              )}
            </Flex>

            {formConfiguration.title}
          </Flex>
        </Flex>
      </Flex>
    </Card>
  )
}
